<template>
  <qx-card title="列表">
    <section slot="titleLeft">
      【出库总额：
      <span class="primary">{{ totalData.outInventoryTotalFee }} 元</span>
      】 【入库总额：
      <span class="primary">{{ totalData.inInventoryTotalFee  }} 元</span>
      】
    </section>
    <section slot="titleRight">
      <qx-permpisions permpisions="10090201">
        <el-button type="primary" plain @click="toEdit()">新增出入库明细</el-button>
      </qx-permpisions>
      <qx-permpisions permpisions="10090202">
        <ExportBtn
          :len="tableData.data.length"
          queryUrl="inventoryManagementBO.ajax?cmd=doQueryInventoryInAndOutDetails"
          :params="fullSearchData"
          bizName="出入库明细数据导出"
          bizCode="exp100902"
          :excelKeys="excelKeys"
          :excelLables="excelLables"
        />
      </qx-permpisions>

      <qx-permpisions permpisions>
        <TableSetting v-model="tableData.title"/>
      </qx-permpisions>
    </section>
    <section class="tablePage">
      <!-- 表格 -->
      <section class="tableBox" ref="tableBox">
        <el-table
          v-loading="tableData.loading"
          ref="multipleTable"
          :data="tableData.data"
          tooltip-effect="dark"
          :height="tableHeight"
          @select="handleSelectionChange"
          @select-all="handleSelectionChange"
        >
          <!-- 常规列表项 -->
          <template v-for="(item, index, key) in tableData.title">
            <el-table-column
              :key="key"
              :prop="item.prop"
              :label="item.label"
              :sortable="item.sortable"
              :filters="item.filters"
              :filter-method="item.filterHandler"
              :min-width="item.minW"
              :width="item.w"
              :fixed="item.fixed"
              v-if="item.show"
            >
            </el-table-column>
          </template>
          <!-- 常规列表项 end -->

          <!-- 操作按钮 -->
          <el-table-column
              prop="control"
              label="操作"
              width="160"
              fixed="right"
          >
            <template slot-scope="scope">
              <TableBtn
                  :tableData="scope.row"
                  :btnList="[
                 {
                    permpisions: '10090203',
                    showCondition: true,
                    name: '删除',
                    event: () => toRemove(scope.row),
                  },
                ]"
              />
            </template>
          </el-table-column>
          <!-- 操按钮 end -->
        </el-table>
      </section>
      <!-- 表格 end -->
      <!-- 分页 -->
      <section class="paginationBox clearPa">
        <!-- 分页组件 -->
        <section class="right">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tableData.page"
            :page-sizes="[10, 20, 50]"
            :page-size="tableData.count"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tableData.total"
          ></el-pagination>
        </section>
        <!-- 分页组件 end -->
      </section>
      <!-- 分页 end -->
    </section>
  </qx-card>
</template>

<script>
import tableMixin from '@qx/mixin/table';
import ExportBtn from 'components/exportBtn';
import TableSetting from 'components/tableSetting/tableSetting';
import TableBtn from 'components/tableBtn/tableBtn';
import {removeInventoryInAndOutDetails, getInventoryDetailsList, getInventoryInAndOutTotalFee} from 'api/service';
export default {
  mixins: [
    tableMixin,
  ],
  components: {
    ExportBtn,
    TableSetting,
    TableBtn,
  },
  data () {
    return {
      totalData: {
        inInventoryTotalFee: 0, // 入库总额
        outInventoryTotalFee: 0, // 出库总额
      },
      tableData: { // 表格相关数据
        loading: false,
        count: 10,
        page: 1,
        total: 0,
        selectResult: [], // 表格选中的结果
        // selectTar: 'orderId',
        title: [ // 表头
          { prop: 'createDate', label: '日期', fixed: true },
          { prop: 'operationType', label: '类型' },
          { prop: 'accessoryName', label: '配件名称' },
          { prop: 'accessoryModel', label: '配件型号' },
          { prop: 'inOutQuantity', label: '数量' },
          { prop: 'unitPrice', label: '单价' },
          { prop: 'totalPrice', label: '总额（元）' },
          { prop: 'remainingInventory', label: '剩余库存' },
          { prop: 'outboundObjectsName', label: '出库对象名称' },
          { prop: 'serviceProvider', label: '入库服务商' },
          { prop: 'serviceProviderAddress', label: '入库服务站点' },
          { prop: 'remarks', label: '备注' },
          { prop: 'outboundObjectsTime', label: '出入库时间' },
          { prop: 'linkman', label: '操作人' },
        ],
        data: [ // 表格内容
        ],
      },
    };
  },
  methods: {
    getList: getInventoryDetailsList,
    async getOtherMsg (params) {
      const res = await getInventoryInAndOutTotalFee(params);
      if (!res.failed) {
        this.totalData = res;
      }
    },
    toEdit () {
      this.jump({
        label: '新增出入库',
        url: '/manage/service/inventoryManagement/inventoryDetail/edit',
      });
    },
    async toRemove (item) {
      const confirmRes = await this.$confirm(`确定要删除这条【${item.operationType}】记录吗`, '温馨提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).catch(() => {
        // 取消操作
      });
      if (confirmRes === 'confirm') {
        const res = await removeInventoryInAndOutDetails({
          id: item.id,
        });
        if (!res.failed) {
          this.$message({
            type: 'success',
            message: '操作成功',
          });
          this.getData();
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.control {
  span {
    margin-right: 16px;
  }
}
</style>
